import React from 'react'
import image from '../images/bg.gif'
import Skill from './Skill'
import Work from './Work'
import resume from '../images/resume.pdf'
import Button from '@mui/material/Button';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

function Home() {
  return (
    <div>
     <div className='h-[85vh] md:h-[95vh] flex flex-wrap justify-center items-end md:items-center ' >
     <div className='flex flex-col  justify-center items-center'>
     <div className='font-bold text-6xl md:text-8xl'>Vishal Garg</div>
        <div className='font-light text-2xl'>{'>'} Programer & Web Developer</div>
     </div>
        <img style={{position:'relative' , zIndex:0}} className='w-3/5' src={image}/>
     </div>
     <Skill/>
     <Work/>
     <div className='font-light text-4xl md:text-6xl flex justify-center mt-[35px] md:mt-[100px]'>Resume</div>
     <div className='flex flex-col items-center m-4 font-light text-2xl h-[25vh]'>
    <div className='m-4'>you can download my resume from below</div>
     <Button variant="contained"><a href={resume} download>download resume <FileDownloadIcon/> </a>
     </Button>
     </div>
     </div> 
    
  )
}

export default Home
